/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Rating_TitleInputs */

const en_us2_engagement_rating_title = /** @type {(inputs: Engagement_Rating_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoying MyPocketGym?`)
};

const pt_br2_engagement_rating_title = /** @type {(inputs: Engagement_Rating_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Está gostando do MyPocketGym?`)
};

const es_419_engagement_rating_title = /** @type {(inputs: Engagement_Rating_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Te gusta MyPocketGym?`)
};

const pt_pt2_engagement_rating_title = /** @type {(inputs: Engagement_Rating_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estás a gostar do MyPocketGym?`)
};

const fr_fr2_engagement_rating_title = /** @type {(inputs: Engagement_Rating_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MyPocketGym te plaît ?`)
};

const de_de2_engagement_rating_title = /** @type {(inputs: Engagement_Rating_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gefällt dir MyPocketGym?`)
};

const it_it2_engagement_rating_title = /** @type {(inputs: Engagement_Rating_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti piace MyPocketGym?`)
};

/**
* | output |
* | --- |
* | "Enjoying MyPocketGym?" |
*
* @param {Engagement_Rating_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_rating_title = /** @type {((inputs?: Engagement_Rating_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Rating_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_rating_title(inputs)
	if (locale === "es-419") return es_419_engagement_rating_title(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_rating_title(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_rating_title(inputs)
	if (locale === "de-DE") return de_de2_engagement_rating_title(inputs)
	if (locale === "it-IT") return it_it2_engagement_rating_title(inputs)
	return en_us2_engagement_rating_title(inputs)
});
export { engagement_rating_title as "engagement.rating_title" }